export const AUTO_TEXTS = [
  "Warm",
  "Reliable",
  "Comforting",
  "Inclusive",
  "Thoughtful",
  "Positive",
  "Trustworthy",
];

export const LINEAR_GRADIENT_TEXTS = [
  "안녕하세요  락앤락입니다.",
  "您好， 这里是乐扣乐扣。",
  "こんにちは、 ロックンロックです。",
  "Hello,  this is LocknLock.",
];

export const INTRODUCTIONS = [
  {
    title: "Delivering Trust Through Lasting  Reliability",
    description:
      "We’re committed to providing deep trust and a strong sense of safety in every product and service we offer.",
  },
  {
    title: "Creating Comfort by Solving Life’s Inconveniences",
    description:
      "From the kitchen to everyday moments, we protect what matters most—bringing peace of mind and building lasting trust.",
  },
  {
    title: "Easing Anxiety with Unwavering  Durability",
    description:
      "Our consistent durability helps ease daily concerns and offers dependable peace of mind, day in and day out.",
  },
];
